export default {
    View_Entity_Approval_Route: "001",
    Edit_Entity_Approval_Route: "002",
    View_Payment_Approval_Route: "003",
    Create_Payment_Approval_Route: "004",
    Edit_Payment_Approval_Route: "005",
    Activate_Payment_Approval_Route: "006",
    Deactivate_Payment_Approval_Route: "007",
    View_Approval_Groups: "008",
    Create_Approval_Groups: "009",
    Edit_Approval_Groups: "010",
    Activate_Approval_Groups: "011",
    Deactivate_Approval_Groups: "012",
    Approve_Entity: "013",
    Approve_Payment: "014",
    View_User: "015",
    Create_User: "016",
    Edit_User: "017",
    Activate_User: "018",
    Deactivate_User: "019",
    Change_Transaction_Pin: "020",
    Reset_Transaction_Pin: "021",
    Reset_User_Password: "022",
    Change_Card_Pin: "023",
    Reset_Card_Pin: "024",
    View_Roles: "025",
    Create_Roles: "026",
    Edit_Roles: "027",
    Activate_Roles: "028",
    Deactivate_Roles: "029",
    View_Super_Corporates: "030",
    Create_Super_Corporates: "031",
    Edit_Super_Corporates: "032",
    Activate_Super_Corporates: "033",
    Deactivate_Super_Corporates: "034",
    View_VAT_Accounts: "035",
    Create_VAT_Accounts: "036",
    Edit_VAT_Accounts: "037",
    Activate_VAT_Accounts: "038",
    Deactivate_VAT_Accounts: "039",
    View_Commission_Accounts: "040",
    Create_Commision_Accounts: "041",
    Edit_Commission_Accounts: "042",
    Activate_Commission_Accounts: "043",
    Deactivate_Commission_Accounts: "044",
    View_Source_Accounts: "045",
    Create_Source_Accounts: "046",
    Edit_Source_Accounts: "047",
    Activate_Source_Accounts: "048",
    Deactivate_Source_Accounts: "049",
    View_Corporates: "050",
    Create_Corporates: "051",
    Edit_Corporates: "052",
    Activate_Corporates: "053",
    Deactivate_Corporates: "054",
    View_Issuers: "055",
    Create_Issuers: "056",
    Edit_Issuers: "057",
    Activate_Issuers: "058",
    Deactivate_Issuers: "059",
    View_Holding_Accounts: "060",
    Create_Holding_Accounts: "061",
    Edit_Holding_Accounts: "062",
    Activate_Holding_Accounts: "063",
    Deactivate_Holding_Accounts: "064",
    View_Fee_Category: "065",
    Create_Fee_Category: "066",
    Edit_Fee_Category: "067",
    Activate_Fee_Category: "068",
    Deactivate_Fee_Category: "069",
    View_Third_Party_Beneficiaries: "070",
    Create_Third_Party_Beneficiaries: "071",
    Edit_Third_Party_Beneficiaries: "072",
    Activate_Third_Party_Beneficiaries: "073",
    Deactivate_Third_Party_Beneficiaries: "074",
    View_Global_Parameters: "075",
    Edit_Global_Parameters: "076",
    Create_Global_Parameters: "077",
    Activate_Global_Parameters: "078",
    Deactivate_Global_Parameters: "079",
    View_Payment_Category: "080",
    Edit_Payment_Category: "081",
    Create_Payment_Category: "082",
    Activate_Payment_Category: "083",
    Deactivate_Payment_Category: "084",
    View_Payment: "085",
    Initiate_Payment: "086",
    Hold_Payment: "087",
    Release_Payment: "088",
    View_Payment_Beneficiaries: "089",
    View_Saved_Payment: "090",
    Save_Payment: "091",
    View_Transaction_Details: "092",
    Update_Transaction_Status: "093",
    Reverse_Transaction: "094",
    Reprocess_Transaction: "095",
    View_Payment_Report: "096",
    Export_Payment_Report: "097",
    View_Transaction_Report: "098",
    Export_Transaction_Report: "099",
    Generate_Settlement_Report: "100",
    View_Settlement_Report: "101",
    Export_Settlement_Report: "102",
    View_Audit_Report: "103",
    Export_Audit_Report: "104",
    View_Commission_Report: "105",
    Export_Commission_Report: "106",
    View_User_Activity_Report: "107",
    Export_User_Activity_Report: "108",
    View_Payment_Authorization_Report: "109",
    Export_Payment_Authorization_Report: "110",
    View_Inflow_Report: "111",
    Export_Inflow_Report: "112",
    View_Outflow_Report: "113",
    Export_Outflow_Report: "114",
    View_Corporate_Report: "115",
    Export_Corporate_Report: "116",
    View_Super_Corporate_Report: "117",
    Export_Super_Corporate_Report: "118",
    Manage_Payment: "119"
};
